import { type AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  useQuery,
  type UseQueryOptions
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { gcpQueryKeys } from 'queries/gcp/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

type GcpMetadataDeploymentResponse = { deploymentTemplateUrl: string }

/* TODO: remove mocks when endpoint is ready */
const USE_MOCK = true

/* TODO: rename function when endpoint is known */
function fetchGcpMetadata({
  queryKey
}: QueryFunctionContext<
  ReturnType<typeof gcpQueryKeys.getMetadataAuthorization>
>) {
  /* TODO: remove mocks when endpoint is ready */
  if (USE_MOCK) {
    return { deploymentTemplateUrl: 'https://example.com' }
  }

  return fetchQueryData<GcpMetadataDeploymentResponse>(
    getEndpointWithParams(...queryKey)
  )
}

/* TODO: rename hook and file when endpoint is known */
export function useGetGcpMetadata(
  options?: Omit<
    UseQueryOptions<GcpMetadataDeploymentResponse, AxiosError>,
    'queryKey' | 'queryFn'
  >
) {
  const { currentTeamId } = useAuth()

  return useQuery({
    ...options,
    queryKey: gcpQueryKeys.getMetadataAuthorization(currentTeamId),
    queryFn: fetchGcpMetadata
  })
}
